import React from 'react'

export default function Header () {

  return (
    <>
      <h1>Country Quiz</h1>
    </>
  )
}